import React, { Component } from 'react';
import './index.scss';
import Loader from 'react-loader-spinner';
import PropTypes from 'prop-types';
import { formatPhone } from '../../utils/phoneNumber';
import { connect } from 'react-redux';
import AlertCard from '../AlertCard';
import { ToastContainer } from 'react-toastify';

import _ from 'lodash';

import { allNotifications } from '../../utils/toastify';
import services from '../../services/services';

const { notifyErrorBottomRight } = allNotifications;

class NewPlan extends Component {
  constructor(props) {
    super(props);
    this.state = {
      alertCard: false,
      alertCardInlegible: false,
      flagElegivel: true,
      loadingBenef: false,
      creden: this.props.codigo,
      nomebenef: '',
      telefone: '',
      codbenef: '',
      contrato: '',
      card: {}
    };
  }

  handleChange = event => {
    const value = event.target.value.replace(/\D/, '')
    this.setState({
      codbenef: Number(value).toString() == '0' ? '' : Number(value).toString()
    });
    // checkPatientInfos
    event.persist();

    if (!this.debouncedFn) {
      this.debouncedFn = _.debounce(() => {
        this.checkPatientInfos();
      }, 750);
    }
    this.debouncedFn();
  };

  handleChangeTel = event => {
    this.setState({
      telefone: formatPhone(event.target.value)
    });
  };

  createPlan = async e => {
    e.preventDefault();
    this.setState({ loading: true });
    const isValid = await this.validarPhone();
    if (isValid) {
      const { nomebenef, telefone, codbenef, creden, flagElegivel } = this.state;

      const paciente = {
        codigoPrestador: creden,
        nome: nomebenef,
        numero_carteirinha: codbenef,
        telefone_beneficiario: telefone,
        flagElegivel
      };

      services
        .mobileengine('adicionarPaciente', paciente)
        .then(res => {
          if (res.status === 201) {
            if (paciente.flagElegivel) {
              this.setState({ alertCard: !this.state.alertCard, card: paciente });
            } else {
              this.setState({ alertCardInlegible: !this.state.alertCardInlegible, card: paciente });
            }
          }
        })
        .catch(error => {
          this.setState({ loading: false });
          this.notify(error.message);
        });
    } else {
      this.setState({ loading: false });
      this.notify('O número de telefone é invalido ou possui todos os dígitos iguais');
    }
  };

  validarPhone = async () => {
    const num = this.state.telefone.substring(5).replace(/-/g, '');
    if (num.match(/^(\d)\1*$/g) == null) {
      return true;
    }
    return false;
  };

  notify = message => notifyErrorBottomRight(message);

  checkPatientInfos = async () => {
    const countCharacters = this.state.codbenef.length;

    if (countCharacters >= 6) {
      this.setState({
        loadingBenef: true,
        flagElegivel: true
      });

      try {
        const responseBenef = await services.beneficiario('getContractNumber', this.state.codbenef);

        const responseElegivel = await services.beneficiario('getElegibility', {
          codBenef: this.state.codbenef,
          contrato: responseBenef.contrato
        });

        this.setState({
          nomebenef: responseBenef.nomeBenef,
          contrato: responseBenef.contrato,
          loadingBenef: false,
          flagElegivel: responseElegivel.flagElegivel
        });
      } catch (err) {
        this.setState({
          nomebenef: '',
          contrato: '',
          loadingBenef: false
        });
        this.notify(err.message);
      }
    } else {
      this.setState({
        nomebenef: '',
        contrato: '',
        flagElegivel: true,
        loadingBenef: false
      });
    }
  };

  render() {
    const {
      alertCard,
      alertCardInlegible,
      nomebenef,
      telefone,
      flagElegivel,
      loadingBenef
    } = this.state;

    const { loading } = this.props;

    const disableCreateNewPlan = !(nomebenef && telefone.length >= 14 && !loading && !loadingBenef);

    return (
      <div className="NewPlan">
        <ToastContainer />

        <div className="row label">
          <p className="col s12 paragraph-blue">Preencha as informações do paciente</p>
        </div>

        <div className="row infos">
          <form onSubmit={this.createPlan}>
            <div className="input-field col s12">
              <input
                id="cardId"
                type="text"
                className="fontWeigth"
                maxLength="18"
                pattern="[0-9]*"
                value={this.state.codbenef}
                onChange={this.handleChange}
              />

              <label htmlFor="cardId" className="active">
                Nº da carteirinha
                {!flagElegivel && (
                  <span>
                    <small className="labelInvalid"> Carteirinha inelegível </small>
                  </span>
                )}
              </label>
            </div>

            <div className="input-field col s12">
              {loadingBenef === false ? (
                <input
                  className="fontWeigth"
                  readOnly
                  id="user_name"
                  type="text"
                  value={nomebenef}
                />
              ) : (
                  <div>
                    <input
                      className="fontWeigth"
                      readOnly
                      id="user_name"
                      type="text"
                      value={nomebenef}
                    />
                    <span className="loadingBenef">
                      <Loader type="Ball-Triangle" height="20" width="20" />
                    </span>
                  </div>
                )}
              <label htmlFor="user_name" className={`${nomebenef.length > 0 ? 'active' : ''}`}>
                Nome do paciente
              </label>
            </div>

            <div className="input-field col s12">
              <input
                className="fontWeigth"
                id="telefone"
                type="text"
                value={telefone}
                maxLength="15"
                onChange={this.handleChangeTel}
              />
              <label htmlFor="telefone" className="active">Telefone do paciente</label>
            </div>

            <div className="input-field col s12">
              <button
                className="addButton btn col s12"
                type="submit"
                disabled={disableCreateNewPlan}
              >
                {loading ? (
                  <div className="createPlanLoader">
                    <Loader type="Ball-Triangle" color="#00BFFF" height="20" width="20" />
                  </div>
                ) : (
                    'Adicionar'
                  )}
              </button>
            </div>

            <AlertCard
              title="Novo paciente adicionado!"
              descriptionHat="Agora você pode incluir os procedimentos para geração de GTOs para esse paciente."
              buttonText="Ir para home"
              goToPath="/home"
              buttonText2="Incluir procedimento"
              goToPath2="/solicitar-gto"
              showResponse={alertCard}
              data={{ data: this.state.card }}
            />

            <AlertCard
              title="Novo paciente adicionado!"
              descriptionHat=""
              buttonText="Ok"
              goToPath="/detalhe-do-tratamento"
              showResponse={alertCardInlegible}
              data={this.state.card}
            />
          </form>
        </div>

        <div className={`overlay-${alertCard ? 'active' : 'hide'}`} />
        <div className={`overlay-${alertCardInlegible ? 'active' : 'hide'}`} />
      </div>
    );
  }
}

NewPlan.propTypes = {
  loading: PropTypes.bool.isRequired,
  codigo: PropTypes.number.isRequired
};

const mapStateToProps = ({ login, application }) => ({
  codigo: login.user.codigo,
  loading: application.loading
});

export default connect(mapStateToProps)(NewPlan);
